import React, { useState, useEffect } from 'react';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import { IoMdRadioButtonOff, IoMdRadioButtonOn, IoIosCheckmarkCircleOutline } from "react-icons/io";

export default function Options({ v, showAllAnswers, student_answer, onChange }) {

    const [answers, setanswers] = useState(false); 
    
    function st_answers(k2) {
        if (student_answer) {
            return false;
        }
        
        let ck = v?.answers?.findIndex(r => r?.true == true);
        let right = false;
        if (ck == k2) {
            right = true;
        }
        
        setanswers(k2);
        if (typeof onChange !== 'undefined') onChange({ ID: v?.ID, answer: k2, right: right });
        
    }

    useEffect(() => {
        if (showAllAnswers) {
            let ck = v?.answers?.findIndex(r => r?.true == true);
            setanswers(ck);
        } else {
            if (student_answer) {
                setanswers(student_answer);
            } else {
                setanswers(false);
            }
        }
    }, [showAllAnswers]);
    
    
    
    return (
        <div className='answersBox'>
            {v?.answers?.map((v2, k2) => { 
                
                return (
                    <a href='javascript:void(0)' onClick={() => st_answers(k2)} className={answers === k2 ? "checked" : "none"}>
                        {answers === k2 ? <IoMdRadioButtonOn /> : <IoMdRadioButtonOff />}
                        <span>{v2?.answer}</span>
                    </a>
                );

                // if (already?.finished) {
                    
                //     return (
                //         <a href='javascript:void(0)' onClick={() => !already && st_answers(v, k2)} className={checked? "checked" : "none"}>
                //             {checked ? <IoMdRadioButtonOn /> : <IoMdRadioButtonOff />}
                //             <span>{ck?.title}</span>
                //         </a>
                //     );
                // } else {

                //     return (
                //         <a href='javascript:void(0)' onClick={() => !already && st_answers(v, k2)} className={checked ? "checked" : "none"}>
                //             {checked ? <IoMdRadioButtonOn /> : <IoMdRadioButtonOff />}
                //             <span>{ck?.title}</span>
                //         </a>
                //     );
                // }
            })}
        </div>
    );
}